import { apiSlice } from "../../apiSlice";
export const aledocxxApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getDataGraphicAleDoc: builder.mutation({
      query: (parameters) => ({
        url: `/Alertxxx/Myalertx/getGraphicDataByUser`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "Alertxxx" },
      }),
    }),
    getClientByFiltersDoc: builder.mutation({
      query: ({CLIIDXXX}) => ({
        url: `/Alertxxx/Aleterlg/getUtocomplCliente/${CLIIDXXX}`,
        method: "GET",
        headers: { modulecima: "Alertxxx" },
      }),
    }),
    getAlertByFilterDoc: builder.mutation({
      query: ({ALENOMXX}) => ({
        url: `/Alertxxx/Aleterlg/getAutocompltAlert/${ALENOMXX}`,
        method: "GET",
        headers: { modulecima: "Alertxxx" },
      }),
    }),
  }),
});

export const { useGetDataGraphicAleDocMutation, useGetAlertByFilterDocMutation, useGetClientByFiltersDocMutation } = aledocxxApiSlice;
